import { render, staticRenderFns } from "./TheFooter2.vue?vue&type=template&id=3a053cc7&scoped=true"
import script from "./TheFooter2.vue?vue&type=script&lang=js"
export * from "./TheFooter2.vue?vue&type=script&lang=js"
import style0 from "./TheFooter2.vue?vue&type=style&index=0&id=3a053cc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a053cc7",
  null
  
)

export default component.exports